<div class="add-labor">
  <!-- Start Add Labor Header -->
  <div class="labor-header mb-0">
    <div class="ui-g-12 flex-between-center py-0">
      <div class="flex-start-center width-100p">
        <i class="far fa-tools header-icon"></i>

        <div class="labor-description width-100p p-relative part-input">
          <app-input id="labor-title" type="text" placeholder="Add labor name*" styleClassInput="width-100p"
            *ngIf="!companyLocalization" [maxLength]="100"
            [theme]="focus?.title || !labor?.title ? 'secondary' : 'light'" [fontSize]="14" [value]="labor.title"
            [errorMessage]="errors.title" [isInvalid]="errors.title" [autoFocus]="true" (appFocus)="focusInput('title')"
            (appBlur)="blurInput('title')" (appChange)="handleChange('title', $event)">
          </app-input>
          <p class="labor-heading" *ngIf="companyLocalization">Labor item</p>
        </div>
        <i id="labor-close-dialog" class="far fa-times pointer dialog-close" (click)="closeDialog()"></i>
      </div>
    </div>
  </div>
  <!-- End Add Labor Header -->
  <p-tabView class="tab-panel-underline tab-panel-estimates tab-panel-default" (onChange)="selectedTab = $event">
    <p-tabPanel [selected]="selectedTab === 0">
      <ng-template pTemplate="header"> Basic info </ng-template>
      <ng-template pTemplate="content">
        <!-- Start Add Labor Body -->
        <div class="ui-g labor-body pt-0 pb-0 border-bottom-light">
          <div class="ui-g-12 inputs-column-spacing labor-inner-body">
            <!-- Basic info section -->
            <div class="input-pricing-info-wrapper input-default-style ui-g-12 p-0 mb-20p"
              *ngIf="isGlobalCategoryEnabled && !isNewCategoriesEnabled">
              <h5 class="input-heading">Basic info</h5>

              <div class="ui-g-12 p-0 flex-start-center flex-wrap">
                <div class="ui-lg-4 ui-g-6 p-0 flex-start-center input-control-container mt-2">
                  <div class="icon flex-center-start">
                    <i class="far fa-tags height-icon"></i>
                  </div>
                  <div class="width-100p pl-1 pr-2">
                    <app-auto-complete id="ac-labor-category" listId="ac-labor-category-list" label="Category"
                      placeholder="Category" field="name" scrollHeight="180px" theme="light" editableItemIdKey="_id"
                      editFieldLabel="Create Category" [floatingLabel]="true" [hasEditableField]="true"
                      [isShowError]="isShowError" [hasFutureSelectionField]="false" [closeOnSelection]="true"
                      [isDropdownIconVisible]="true" [hasStaticUnassignedFiled]="false" [suggestions]="categoryResults"
                      [listItemFontSize]="14" [fontSize]="14" [value]="labor.category?.name || ''"
                      (appFocus)="showSuggestions('tags')" (appBlur)="blurInput('category')"
                      (appUpdateItem)="onUpdateItem($event, config?.tags?.labor)"
                      (appSelect)="onAutoCompleteSelect($event, 'tags')" (appSave)="saveCategory($event)"
                      (appChange)="handleChangeCategory(config?.tags?.labor, $event)"
                      (appCompletedMethod)="searchSuggestionCategory($event, 'tags')"
                      (appClear)="onClearSuggestion('tags')">
                      <ng-template let-item let-editItem="editItem" appTemplate="item">
                        <div class="tag-item flex-between-center">
                          <div>
                            <span>{{ item?.name }}</span>
                          </div>
                          <div class="tag-item-action flex-end-center">
                            <i class="fas fa-pencil p-1 mr-2" [hidden]="item?.nameSort === 'unassigned'"
                              (click)="$event.stopPropagation(); item?.nameSort === 'unassigned' ? return : editItem(item)"></i>
                            <i class="fa fa-trash p-1 mr-2" [hidden]="item?.nameSort === 'unassigned'"
                              (click)="$event.stopPropagation(); item?.nameSort === 'unassigned' ? return : deleteCategoryDialog(item)"></i>
                          </div>
                        </div>
                      </ng-template>
                    </app-auto-complete>
                  </div>
                </div>
              </div>
            </div>
            <!-- basic info section ends-->


            <!-- Name section -->
            <div class="input-pricing-info-wrapper input-default-style ui-g-12 p-0 mb-20p" *ngIf="companyLocalization">
              <div class="ui-g-12 p-0 input-control-container">
                <div class="ui-g-8 ui-lg-8 p-0 d-flex" [ngClass]="{'flex-row-reverse': currentLang === 'fr'}">
                  <div class=" ui-lg-6 ui-g-6 p-0 flex-start-center">
                    <div class="icon flex-center-start">
                      <i class="far fa-tools"></i>
                    </div>

                    <div class="width-100p pl-1 pr-2">
                      <app-input id="labor-title" type="text"
                        placeholder="Labor name (EN){{ currentLang === 'en'? '*' : '' }}" styleClassInput="width-100p"
                        [maxLength]="100" [fontSize]="14" [value]="labor.title" [errorMessage]="errors.title"
                        [isInvalid]="errors.title" [autoFocus]="true" (appFocus)="focusInput('title')"
                        (appBlur)="blurInput('title')" (appChange)="handleChange('title', $event)">
                      </app-input>
                    </div>
                  </div>

                  <div class="ui-lg-6 ui-g-6 p-0 flex-start-center">
                    <div class="icon flex-center-start">
                      <i class="far fa-tools"></i>
                    </div>

                    <div class="width-100p pl-1 pr-2">
                      <app-input id="labor-title" type="text"
                        placeholder="Labor name (FR){{ currentLang === 'fr'? '*' : '' }}" styleClassInput="width-100p"
                        [maxLength]="100" [fontSize]="14" [value]="labor.titleFR" [errorMessage]="errors.titleFR"
                        [isInvalid]="errors.titleFR" [autoFocus]="true" (appFocus)="focusInput('titleFR')"
                        (appBlur)="blurInput('titleFR')" (appChange)="handleChange('titleFR', $event)">
                      </app-input>
                    </div>
                  </div>
                </div>
                <div class="ui-lg-4 ui-g-6 p-0 flex-start-center">
                </div>
              </div>
            </div>
            <!-- Name section ends-->

            <div *ngIf="isNewCategoriesEnabled" class="input-basic-info-wrapper input-default-style ui-g-12 p-0">
              <h5 class="input-heading">
                Item classification <span><i class="fas fa-info-circle"></i></span>
              </h5>

              <div class="ui-g-12 p-0 input-control-container" tooltipPosition="top"
                tooltipStyleClass="tooltip-width-medium text-center"
                [pTooltip]="!canEditClassifications ? classificationPrivilegeMsg : ''">
                <!-- add flag here -->
                <app-category-search class="search-category-field" subId="1" [type]="'labor'"
                  [placeholder]="'Search category'" [canEditClassifications]="canEditClassifications"
                  (appSelect)="onSelectCategory($event)"></app-category-search>
              </div>

              <div class="ui-g-12 p-0">
                <div class="ui-g-4" tooltipPosition="top" tooltipStyleClass="tooltip-width-medium text-center"
                  [pTooltip]="!canEditClassifications ? classificationPrivilegeMsg : ''">
                  <app-auto-complete id="standard-category" listId="standard-category-list" field="categoryName"
                    label="Standard Category" placeholder="Standard Category" scrollHeight="186px" theme="light"
                    [value]="labor?.category?.categoryName" [fontSize]="14" [listItemFontSize]="14"
                    [floatingLabel]="true" [listItemFontSize]="13" [disabled]="!canEditClassifications"
                    [suggestions]="categoriesSuggestionsResults" [isDropdownIconVisible]="true"
                    [isLoading]="loader?.category" (appFocus)="focusInput('category')" (appBlur)="blurInput('category')"
                    (appSelect)="categoryDropdownSelect('category', $event)"
                    (appCompletedMethod)="searchItemCategory('category', $event)"
                    (appClear)="handleClear('category')"></app-auto-complete>
                </div>
                <div class="ui-g-4" tooltipPosition="top" tooltipStyleClass="tooltip-width-medium text-center"
                  [pTooltip]="!canEditClassifications ? classificationPrivilegeMsg : ''">
                  <app-auto-complete id="standard-subcategory" listId="standard-subcategory-list"
                    field="subCategoryName" label="Standard Subcategory" placeholder="Standard Subcategory"
                    scrollHeight="186px" theme="light" [value]="labor.category?.subCategoryName" [fontSize]="14"
                    [listItemFontSize]="14" [floatingLabel]="true" [listItemFontSize]="13"
                    [suggestions]="subCategoriesSuggestionsResults" [isDropdownIconVisible]="true"
                    [disabled]="!labor.category?.categoryId || !canEditClassifications"
                    [isLoading]="loader?.subCategory" (appFocus)="focusInput('subCategory')"
                    (appBlur)="blurInput('subCategory')" (appSelect)="categoryDropdownSelect('subCategory', $event)"
                    (appCompletedMethod)="searchItemCategory('subCategory', $event)"
                    (appClear)="handleClear('subCategory')"></app-auto-complete>
                </div>
                <div class="ui-g-4" tooltipPosition="top" tooltipStyleClass="tooltip-width-medium text-center"
                  [pTooltip]="!canEditClassifications ? classificationPrivilegeMsg : ''">
                  <app-auto-complete id="standard-labor" listId="standard-labor-list" field="subSubCategoryName"
                    label="Standard Labor Type" placeholder="Standard Labor Type" scrollHeight="186px" theme="light"
                    [value]="labor.category?.subSubCategoryName" [fontSize]="14" [listItemFontSize]="14"
                    [floatingLabel]="true" [listItemFontSize]="13" [isLoading]="loader?.subSubCategory"
                    [disabled]="!labor.category?.subCategoryId || !canEditClassifications"
                    [suggestions]="subSubCategoriesSuggestionsResults" [isDropdownIconVisible]="true"
                    (appFocus)="focusInput('subSubCategory')" (appBlur)="blurInput('subSubCategory')"
                    (appSelect)="categoryDropdownSelect('subSubCategory', $event)"
                    (appCompletedMethod)="searchItemCategory('subSubCategory', $event)"
                    (appClear)="handleClear('subSubCategory')"></app-auto-complete>
                </div>
              </div>
            </div>

            <!-- Sales Code -->
            <div *ngIf="isNewCategoriesEnabled && isSalesCodeEnabled"
              class="ui-g-4 p-0 flex-start-center not-allowed my-2" tooltipPosition="top"
              tooltipStyleClass="tooltip-width-medium text-center"
              [pTooltip]="!canEditClassifications && !isOpenFromRO ? classificationPrivilegeMsg : (labor?.salesCode?.title === 'Unassigned' || !labor?.salesCode?.title) ? 'Click here to assign sales code' : ''">

              <div class="width-100p pl-1 pr-2">
                <app-input id="sales-code" type="text" placeholder="Sales Code" theme="primary" [fontSize]="14"
                  [rightIcon]="!labor?.salesCode?.shortName ? 'fas fa-plus-circle font-warning pointer' : ''"
                  [imgIcon]="labor?.salesCode?.shortName ? 'assets/img/icon/edit-outline.svg' : ''"
                  imgIconClass="pointer" (iconClicked)="openAssignSalesCodeDialog()" name="sales-code"
                  [value]="displaySalesCodeTitle()" [floatingLabel]="true" [maxLength]="50" [disabled]="true">
                </app-input>
              </div>
            </div>

            <!-- Pricing info section -->
            <div class="input-pricing-info-wrapper input-default-style ui-g-12 p-0 mb-20p">
              <h5 class="input-heading">Pricing</h5>

              <div class="ui-g-12 p-0 flex-start-center flex-wrap">
                <!-- MOTOR billable hours -->
                <div *ngIf="labor?.itemSource === 'Motor'"
                  class="ui-lg-4 ui-g-6 p-0 flex-start-center input-control-container mt-2">
                  <div class="icon flex-center-start">
                    <i class="far fa-stopwatch height-icon"></i>
                  </div>

                  <div class="width-100p pl-1 pr-2 permanent-disabled-field">
                    <app-input id="acutal-billable-hours" type="text" placeholder="MOTOR billable hours*"
                      [disabled]="true" [floatingLabel]="true" [allowDecimal]="true" [fontSize]="14" theme="light"
                      name="actualLaborTime" [isInvalid]="errors.actualLaborTime" [maxLength]="50"
                      [selectTextOnFocus]="true"
                      [value]="focus.actualLaborTime ? labor.actualLaborTime : (labor.actualLaborTime | number : '1.2-2')"
                      (appFocus)="focusInput('actualLaborTime')" (appBlur)="blurInput('actualLaborTime')"
                      (appChange)="handleChange('actualLaborTime', $event)">
                    </app-input>
                  </div>
                </div>

                <!-- Hours matrix -->
                <div *ngIf="labor?.itemSource === 'Motor'"
                  class="ui-lg-4 ui-g-6 p-0 flex-start-center input-control-container mt-2">
                  <div class="icon flex-center-start">
                    <i class="far fa-th height-icon"></i>
                  </div>

                  <div class="width-100p pl-1 pr-2 permanent-disabled-field">
                    <app-dropdown id="labor-hour-matrix" placeholder="Hours matrix"
                      label="Hours matrix {{ numberObj(labor?.billableHours) === numberObj(labor?.markedUpLaborTime) ? '(Applied)' : '(Unapplied)' }}"
                      field="name" theme="light" name="hoursMatrix" [disabled]="true" [floatingLabel]="true"
                      [fontSize]="14" [hasError]="errors.hoursMatrix" [errorMessage]=""
                      [value]="{ name: motorMarkup + '%' }" [options]="laborPricings" [isDropdownIconVisible]="true">
                    </app-dropdown>
                  </div>
                </div>

                <!-- Billable hours -->
                <div class="ui-lg-4 ui-g-6 p-0 flex-start-center input-control-container mt-2">
                  <div class="icon flex-center-start">
                    <i class="far fa-stopwatch height-icon"></i>
                  </div>

                  <div class="width-100p pl-1 pr-2 position-relative">
                    <app-input id="labor-billable-hours" type="text" placeholder="Billable hours*"
                      label="Billable hours* {{ numberObj(labor?.billableHours) === numberObj(labor?.markedUpLaborTime) ? '(Calculated)' : '(Manually entered)' }}"
                      [floatingLabel]="true" [allowDecimal]="true" [fontSize]="14" theme="light" name="billableHours"
                      [isInvalid]="errors.billableHours" [maxLength]="50" [selectTextOnFocus]="true"
                      [value]="focus.billableHours ? labor.billableHours : (labor.billableHours | number : '1.2-2')"
                      (appFocus)="focusInput('billableHours')" (appBlur)="blurInput('billableHours')"
                      (appChange)="handleChange('billableHours', $event)">
                    </app-input>

                    <i *ngIf="numberObj(labor?.billableHours) !== numberObj(labor?.markedUpLaborTime)"
                      class="fal fa-undo apply-markup-icon pointer" pTooltip="Apply labor time markup"
                      (click)="handleRevertToMarkUp($event)"></i>
                  </div>
                </div>

                <div class="ui-lg-4 ui-g-6 p-0 flex-start-center input-control-container mt-2">
                  <div class="icon flex-center-start">
                    <i class="far fa-usd-circle height-icon"></i>
                  </div>

                  <div class="width-100p pl-1 pr-2">
                    <app-dropdown id="labor-bill-rates" placeholder="Labor rate*" [floatingLabel]="true"
                      label="Labor rate*" theme="light" name="billRate" [fontSize]="14" [hasError]="errors.billRate"
                      [errorMessage]="" [value]="labor.billRate" [options]="laborPricings"
                      [isDropdownIconVisible]="true"
                      [disabled]="(!isOpenFromRO && isPricingManagementEnable && !isPricingMatricesManagement && (isNewItemCategoriesEnable || isAttributeBasedPricingEnable)) "
                      tooltipPosition="top"
                      [pTooltip]="(!isOpenFromRO && isPricingManagementEnable && !isPricingMatricesManagement && (isNewItemCategoriesEnable || isAttributeBasedPricingEnable))  ? 'Please contact admin / store manager to update' : ''"
                      (appSelect)="handleSelect('billRate', $event)" (appOpenDropdown)="focusInput('billRate')"
                      (appClickOutside)="blurInput('billRate')">
                    </app-dropdown>
                  </div>
                </div>
                <div *ngIf="labor?.itemSource === 'Motor'"
                  class="ui-lg-4 ui-g-6 p-0 flex-start-center input-control-container mt-2"></div>

                <div class="ui-lg-4 ui-g-6 p-0 flex-start-center input-control-container mt-2">
                  <div class="icon flex-center-start">
                    <i class="far fa-tag height-icon"></i>
                  </div>

                  <div class="width-100p pl-1">
                    <app-input id="labor-total-price" type="text" placeholder="Total price" theme="light" name="price"
                      [allowDecimal]="focus.price ? true : false" [fontSize]="14"
                      [disabled]="(!isOpenFromRO && isPricingManagementEnable && !isPricingMatricesManagement && (isNewItemCategoriesEnable || isAttributeBasedPricingEnable)) "
                      [pTooltip]="(!isOpenFromRO && isPricingManagementEnable && !isPricingMatricesManagement && (isNewItemCategoriesEnable || isAttributeBasedPricingEnable)) ? 'Please contact admin / store manager to update' : ''"
                      [floatingLabel]="true" [value]="focus.price ? labor.price : (labor.price | currency : usd)"
                      [maxLength]="50" (appFocus)="focusInput('price')" (appBlur)="blurInput('price')"
                      (appChange)="handleChange('price', $event)">
                    </app-input>
                  </div>
                </div>
              </div>
            </div>
            <!-- Pricing info section ends-->

            <!-- Cost section -->
            <div class="input-pricing-info-wrapper input-default-style ui-g-12 p-0 mb-20p">
              <h5 class="input-heading">Cost</h5>

              <div class="ui-g-12 p-0 input-control-container">
                <div class="ui-lg-4 ui-g-6 p-0 flex-start-center">
                  <div class="icon flex-center-start">
                    <i class="far fa-clock height-icon"></i>
                  </div>

                  <div class="width-100p pl-1 pr-2">
                    <app-input id="labor-estimate-hours" type="text" placeholder="Estimated hours*"
                      [allowDecimal]="true" theme="light" name="costEstimatedHours" [fontSize]="14"
                      [isInvalid]="errors.costEstimatedHours" [floatingLabel]="true" [selectTextOnFocus]="true"
                      [value]="focus.costEstimatedHours ? labor.costEstimatedHours : (labor.costEstimatedHours | number : '1.2-2')"
                      [maxLength]="50" (appFocus)="focusInput('costEstimatedHours')"
                      (appBlur)="blurInput('costEstimatedHours')"
                      (appChange)="handleChange('costEstimatedHours', $event)">
                    </app-input>
                  </div>
                </div>

                <div class="ui-lg-4 ui-g-6 p-0 flex-start-center">
                  <div class="icon flex-center-start">
                    <i class="far fa-usd-circle height-icon"></i>
                  </div>

                  <div class="width-100p pl-1 pr-2">
                    <app-input id="labor-rate" type="text" placeholder="Rate*"
                      [allowDecimal]="focus.costRate ? true : false" theme="light" name="costRate" [fontSize]="14"
                      [isInvalid]="errors.costRate" [floatingLabel]="true" [isInvalid]="errors.costRate"
                      [selectTextOnFocus]="true"
                      [value]="focus.costRate ? labor.costRate : (labor.costRate | currency : usd)" [maxLength]="50"
                      (appFocus)="focusInput('costRate')" (appBlur)="blurInput('costRate')"
                      (appChange)="handleChange('costRate', $event)">
                    </app-input>
                  </div>
                </div>

                <div class="ui-lg-4 ui-g-6 p-0 flex-start-center">
                  <div class="icon flex-center-start">
                    <i class="far fa-receipt height-icon"></i>
                  </div>

                  <div class="width-100p pl-1">
                    <app-input id="labor-total-cost" type="text" placeholder="Total cost" theme="light" name="cost"
                      [disabled]="true" [allowDecimal]="focus.cost ? true : false" [isInvalid]="errors.cost"
                      [floatingLabel]="true" [fontSize]="14"
                      [value]="focus.cost ? labor.cost : (labor.cost | currency : usd)" [maxLength]="50"
                      (appFocus)="focusInput('cost')" (appBlur)="blurInput('cost')"
                      (appChange)="handleChange('cost', $event)">
                    </app-input>
                  </div>
                </div>
              </div>
            </div>
            <!-- Cost section ends-->

            <!-- General settings info section -->
            <div class="input-general-settings-wrapper input-default-style ui-g-12 p-0 mb-0">
              <h5 class="input-heading">General settings</h5>

              <div class="ui-g-12 p-0 input-control-container">
                <!-- Taxable -->
                <div class="ui-g-4 p-0 flex-start-center">
                  <div class="icon flex-center-start">
                    <i class="far fa-landmark-alt height-icon"></i>
                  </div>

                  <div class="width-100p pl-1 pr-2">
                    <app-switch-pill id="labor-taxable" label="Taxable" position="end" styleClassLabel="font-gray-35"
                      [fontSize]="12" [isActive]="labor.isTaxable" (appChange)="handleChange('isTaxable', $event)">
                    </app-switch-pill>
                  </div>
                </div>

                <!-- Display description -->
                <div class="ui-g-4 p-0 flex-start-center">
                  <div class="icon flex-center-start">
                    <i class="far fa-boxes height-icon"></i>
                  </div>

                  <div class="width-100p pl-1 pr-2">
                    <app-switch-pill label="Display desc. on estimate & invoice" position="end"
                      styleClassLabel="font-gray-35" [fontSize]="12" [isActive]="labor.displayDescOnOrder"
                      (appChange)="handleChange('displayDescOnOrder', $event)">
                    </app-switch-pill>
                  </div>
                </div>

                <!-- Commissionable -->
                <div *ngIf="isCommissionPlanEnabled" class="ui-g-4 p-0 flex-start-center">
                  <div class="icon flex-center-start">
                    <i class="far fa-sack height-icon"></i>
                  </div>

                  <div class="width-100p pl-1 pr-2">
                    <app-switch-pill label="Commissionable" position="end" styleClassLabel="font-gray-35"
                      [fontSize]="12" [isActive]="labor.commissionable"
                      (appChange)="handleChange('commissionable', $event)">
                    </app-switch-pill>
                  </div>
                </div>
              </div>

              <div class="ui-g-12 p-0 input-control-container">
                <!-- Status -->
                <div class="ui-g-4 p-0 flex-start-center">
                  <div class="icon flex-center-start">
                    <i class="far fa-info-circle height-icon"></i>
                  </div>
                  <div class="width-100p pl-1 pr-2">
                    <app-switch-pill id="labor-status" position="end" styleClassLabel="font-gray-35"
                      [disabled]="!!orderServiceId && !updateGenericItem" [label]="labor.status ? 'Active' : 'Inactive'"
                      [fontSize]="12" [isActive]="labor.status" (appChange)="handleChange('status', $event)">
                    </app-switch-pill>
                  </div>
                </div>

                <!-- Display hours -->
                <div class="ui-g-4 p-0 flex-start-center">
                  <div class="icon flex-center-start">
                    <i class="far fa-file-invoice height-icon"></i>
                  </div>

                  <div class="width-100p pl-1 pr-2">
                    <app-switch-pill id="labor-display-hour" label="Display hrs. & price on estimate & invoice"
                      position="end" styleClassLabel="font-gray-35" [isActive]="labor.displayHoursOnOrder"
                      [fontSize]="12" (appChange)="handleChange('displayHoursOnOrder', $event)">
                    </app-switch-pill>
                  </div>
                </div>

                <!-- QuickBooks reference -->
                <div *ngIf="isQboConnected" class="ui-g-4 p-0 flex-start-center">
                  <div class="icon flex-center-start">
                    <i class="far fa-coins height-icon"></i>
                  </div>

                  <div class="width-100p pl-1">
                    <div class="qbo-autocomplete">
                      <app-auto-complete id="labor-qbo-ref" label="QBO item reference" placeholder="QBO item reference"
                        theme="light" scrollHeight="179px" name="itemRef" styleClassInputWrapper="pl-0"
                        styleClassInput="pl-0" field="title" [value]="labor?.itemRef?.title" [fontSize]="14"
                        [listItemFontSize]="14" [suggestions]="qboItemRefs" [isDropdownIconVisible]="true"
                        [floatingLabel]="true" (appFocus)="focusInput('itemRef')" (appBlur)="blurInput('itemRef')"
                        (appClear)="handleClear()" (appCompletedMethod)="onSearchItem($event)"
                        (appSelect)="handleSelect('itemRef', $event)">
                      </app-auto-complete>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="d-flex" [ngClass]="{'flex-row-reverse': currentLang === 'fr'}"> -->
              <div *ngIf="companyLocalization else singleDescriptionField">
                <div *ngIf="currentLang==='en' else reverseTemplate">
                  <div class="ui-g-12 p-0 input-control-container mt-3">
                    <div class="ui-g-12 p-0 flex-start-center">
                      <div class="icon flex-center-start" [ngClass]="{ active: activeInput === 'note' }">
                        <i class="far fa-sticky-note height-icon"></i>
                      </div>
                      <div class="width-100p pl-1">
                        <app-textarea id="labor-description" theme="light" placeholder="Labor description (EN)"
                          textAreaId="labor-save-dialog" [maxLength]="10000" [autoGrow]="true" [fontSize]="14"
                          [floatingLabel]="true" [maxAutoGrowHeight]="64" [isInvalid]="errors.notes" [rows]="1"
                          [value]="labor.notes" (appChange)="handleChange('notes', $event)"
                          (appFocus)="focusInput('notes')" (appBlur)="blurInput('notes')">
                        </app-textarea>
                      </div>
                    </div>
                  </div>
                  <div class="ui-g-12 p-0 input-control-container mt-3">
                    <div class="ui-g-12 p-0 flex-start-center">
                      <div class="icon flex-center-start" [ngClass]="{ active: activeInput === 'note' }">
                        <i class="far fa-sticky-note height-icon"></i>
                      </div>

                      <div class="width-100p pl-1">
                        <app-textarea id="labor-description" theme="light" placeholder="Labor description (FR)"
                          textAreaId="labor-save-dialog" [maxLength]="10000" [autoGrow]="true" [fontSize]="14"
                          [floatingLabel]="true" [maxAutoGrowHeight]="64" [isInvalid]="errors.descriptionFR" [rows]="1"
                          [value]="labor.descriptionFR" (appChange)="handleChange('descriptionFR', $event)"
                          (appFocus)="focusInput('descriptionFR')" (appBlur)="blurInput('descriptionFR')">
                        </app-textarea>
                      </div>
                    </div>
                  </div>
                </div>
                <ng-template #reverseTemplate>
                  <div class="ui-g-12 p-0 input-control-container mt-3">
                    <div class="ui-g-12 p-0 flex-start-center">
                      <div class="icon flex-center-start" [ngClass]="{ active: activeInput === 'note' }">
                        <i class="far fa-sticky-note height-icon"></i>
                      </div>
                      <div class="width-100p pl-1">
                        <app-textarea id="labor-description" theme="light" placeholder="Labor description (FR)"
                          textAreaId="labor-save-dialog" [maxLength]="10000" [autoGrow]="true" [fontSize]="14"
                          [floatingLabel]="true" [maxAutoGrowHeight]="64" [isInvalid]="errors.descriptionFR" [rows]="1"
                          [value]="labor.descriptionFR" (appChange)="handleChange('descriptionFR', $event)"
                          (appFocus)="focusInput('descriptionFR')" (appBlur)="blurInput('descriptionFR')">
                        </app-textarea>
                      </div>
                    </div>
                  </div>

                  <div class="ui-g-12 p-0 input-control-container mt-3">
                    <div class="ui-g-12 p-0 flex-start-center">
                      <div class="icon flex-center-start" [ngClass]="{ active: activeInput === 'note' }">
                        <i class="far fa-sticky-note height-icon"></i>
                      </div>
                      <div class="width-100p pl-1">
                        <app-textarea id="labor-description" theme="light" placeholder="Labor description (EN)"
                          textAreaId="labor-save-dialog" [maxLength]="10000" [autoGrow]="true" [fontSize]="14"
                          [floatingLabel]="true" [maxAutoGrowHeight]="64" [isInvalid]="errors.notes" [rows]="1"
                          [value]="labor.notes" (appChange)="handleChange('notes', $event)"
                          (appFocus)="focusInput('notes')" (appBlur)="blurInput('notes')">
                        </app-textarea>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </div>

              <ng-template #singleDescriptionField>
                <div class="ui-g-12 p-0 input-control-container mt-3">
                  <div class="ui-g-12 p-0 flex-start-center">
                    <div class="icon flex-center-start" [ngClass]="{ active: activeInput === 'note' }">
                      <i class="far fa-sticky-note height-icon"></i>
                    </div>

                    <div class="width-100p pl-1">
                      <app-textarea id="labor-description" theme="light" placeholder="Labor description"
                        textAreaId="labor-save-dialog" [maxLength]="10000" [autoGrow]="true" [fontSize]="14"
                        [floatingLabel]="true" [maxAutoGrowHeight]="64" [isInvalid]="errors.notes" [rows]="1"
                        [value]="labor.notes" (appChange)="handleChange('notes', $event)"
                        (appFocus)="focusInput('notes')" (appBlur)="blurInput('notes')">
                      </app-textarea>
                    </div>
                  </div>
                </div>
              </ng-template>

              <div class="ui-g-12 p-0 input-control-container mt-2">
                <div class="ui-g-12 p-0 flex-start-center">
                  <div class="icon flex-center-start" [ngClass]="{ active: activeInput === 'internalNotes' }">
                    <i class="far fa-sticky-note height-icon"></i>
                  </div>

                  <div class="width-100p pl-1">
                    <app-textarea id="internal-labor-desc" theme="light" placeholder="Internal notes"
                      textAreaId="internal-labor-desc-textarea" [autoGrow]="true" [fontSize]="14" [floatingLabel]="true"
                      [maxAutoGrowHeight]="64" [isInvalid]="errors.internalNotes" [rows]="1"
                      [value]="labor.internalNotes" (appChange)="handleChange('internalNotes', $event)"
                      (appFocus)="focusInput('internalNotes')" (appBlur)="blurInput('internalNotes')">
                    </app-textarea>
                  </div>
                </div>
              </div>
            </div>

            <!-- Inventory section ends -->
            <div *ngIf="isFeeAssociationEnabled" class="input-default-style ui-g-12 p-0 mb-3">
              <h5 class="input-heading">Fee</h5>

              <div class="hazmat-fee-wrapper" *ngFor="let hazmatFee of hazmatFeeArray; let index = index">
                <div class="hazmat-wrapper">
                  <div class="hazmat-fee-search-wrapper">
                    <app-auto-complete placeholder="Search Fee" field="title" theme="primary" leftIcon="fad fa-hard-hat"
                      styleClassInputWrapper="p-0 pl-1" styleClassInput="p-1" width="500px" [disabled]="isOpenFromRO"
                      [isLoading]="isSearching" [value]="helperService.getLocalizationValue(currentLang, hazmatFee, 'title')" [fontSize]="14" [hasEditableField]="false"
                      [openDropdownOnGetResult]="true" [hasSearchIcon]="true" [closeOnSelection]="true"
                      [suggestions]="itemResults[index]" (appSelect)="onROSelect($event, index)"
                      (appClear)="onSearchClear(index)" (appCompletedMethod)="searchSuggestion($event, index)"
                      (appEnter)="onSearchEnter($event)" scrollHeight="288px">
                      <ng-template let-item let-query="query" appTemplate="item">
                        <div class="fee-search-item flex-start-center width-100p">
                          <i class="fal far fa-usd-circle font-gray-75 p-2"></i>
                          <div class="flex-start-center width-100p">
                            <div class="flex-column width-100p">
                              <div class="search-item-header flex-between-center width-100p">
                                <div class="search-title-wrapper">
                                  <p class="m-0 text-truncate search-title">{{ helperService.getLocalizationValue(currentLang, item, 'title')}}</p>
                                  <p class="m-0 text-truncate font-11 font-gray-55 search-description width-100p">
                                    {{ helperService.getLocalizationValue(currentLang, item, 'description', true) || 'No description' }}
                                  </p>
                                </div>

                                <div class="m-0 text-truncate search-price-cost width-100p text-right">
                                  <p class="search-price m-0 font-600">Price: {{ item.price || 0 | currency : usd }}</p>
                                  <p class="search-cost m-0">Cost: {{ item.cost || 0 | currency : usd }}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </app-auto-complete>
                  </div>

                  <p *ngIf="hazmatFee?.feeValueType && hazmatFee?.feeValueType === 'percent'; else typeFixedTemplate">
                    * Total fee will be equal to {{ (hazmatFee?.price / 100) * labor.billRate.rate || 0 | currency : usd
                    }} per unit of the item ({{ hazmatFee?.price }}% *
                    {{ labor.billRate.rate || 0 | currency : usd }})
                  </p>

                  <ng-template #typeFixedTemplate>
                    <p>* Total fee will be equal to {{ hazmatFee?.price || 0 | currency : usd }} per unit of the item
                    </p>
                  </ng-template>
                </div>

                <div class="deleteButton" *ngIf="hazmatFee?._id && !isOpenFromRO">
                  <button class="del-btn" (click)="removeHazmatFee(index)">
                    <i class="fal fa-trash"></i>
                  </button>
                </div>
              </div>

              <p *ngIf="!isOpenFromRO" class="mt-1 mb-4 font-primary font-600 pointer" (click)="addAnotherFee()">
                <ng-container *ngIf="hazmatFeeArray.length > 0; else showFeeText"> <i
                    class="fad fa-plus-circle mr-2"></i>
                  Add another fees </ng-container>

                <ng-template #showFeeText> <i class="fad fa-plus-circle mr-2"></i> Add another fee </ng-template>
              </p>
            </div>
            <!-- General settings info section ends -->
          </div>
        </div>

        <!-- End Add Labor Body -->

        <!-- Start Add Labor Footer -->
        <div class="ui-g-12 flex-between-center dialog-footer labor-footer">
          <div class="part-add-dialog-footer d-flex justify-content-between width-100p">
            <div>
              <span
                [ngClass]="{ invisible: isLocal || !orderServiceId || ['cannedService', 'catalog'].includes(openFrom) }"
                class="width-100p">
                <app-checkbox [inputId]="'cb-part-add-another'" label="Also update labor across application"
                  [isChecked]="updateGenericItem"
                  [disabled]="isPricingManagementEnable && (labor.isChangeInPriceMatrix || isChangeInPriceMatrix) "
                  tooltipPosition="top" tooltipStyleClass="tooltip-width-200"
                  [pTooltip]="isPricingManagementEnable && (labor.isChangeInPriceMatrix || isChangeInPriceMatrix) ? 'Current pricing is different from default. Please contact admin / store manager to update' : ''"
                  (appChange)="updateGenericItem = $event; labor.status = defaultActiveState">
                </app-checkbox>
              </span>
            </div>

            <div>
              <button class="btn btn-border pointer btn-submit mr-1" (click)="closeDialog()">Cancel</button>
              <button class="btn btn-primary pointer btn-submit mr-1" tooltipPosition="top"
                [pTooltip]="isLockedRO ? 'Sorry, cannot make any changes to a Locked RO':isFinalizedRo ? 'Sorry, cannot make any changes to a finalized RO' : ''"
                [disabled]="isProcessing || isFinalizedRo || isLockedRO" (click)="onSubmit()">
                <span [ngClass]="{ 'pr-2': isProcessing }">Save</span>
                <i *ngIf="isProcessing" class="far fa-spinner rotate"></i>
              </button>
            </div>
          </div>
        </div>
        <!-- End Add Labor Footer -->
      </ng-template>
    </p-tabPanel>

    <p-tabPanel [selected]="selectedTab === 1">
      <ng-template pTemplate="header"> Activity logs </ng-template>
      <ng-template pTemplate="content">
        <div class="activity-logs">
          <div class="catalog-activity-wrapper">
            <!-- Activity logs -->
            <div *ngIf="activityLogs?.length" class="catalog-activity-inner-wrapper ui-g-12 scroll-activity-log" (scroll)="onScroll($event)">
              <div *ngFor="let activityLog of activityLogs">
                <app-catalog-activity-logs [activityLog]="activityLog"></app-catalog-activity-logs>
              </div>
            </div>

            <div *ngIf="!activityLogs?.length" class="catalog-activity-inner-wrapper no-activity-logs p-3">
              <p>There are no activity logs.</p>
            </div>

            <!-- Filter wrapper -->
            <!-- <div hidden class="filter-ddl-wrapper">
              <div class="dropdown">
                <div class="btn dropdown-toggle" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Filter &nbsp;
                  <i *ngIf="isFilterLoading" class="fal fa-spinner rotate"></i>
                  <span *ngIf="filterOption?.length" class="filter-count-bubble">{{ filterOption?.length }}</span>
                </div>

                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuLink">
                  <ul class="catalog-list-filter">
                    <li class="catalog-list-filter-items" (click)="$event.stopPropagation()">
                      <app-checkbox
                        label="Item history"
                        [disabled]="isFilterLoading"
                        [isChecked]="filterOptionModel.itemHistory"
                        [fontSize]="12"
                        (appChange)="onCheckboxChange($event, 'catalog-item')"
                      >
                      </app-checkbox>
                    </li>
                    <li class="catalog-list-filter-items" (click)="$event.stopPropagation()">
                      <app-checkbox
                        label="Purchase history"
                        [disabled]="isFilterLoading"
                        [isChecked]="filterOptionModel.purchaseHistory"
                        [fontSize]="12"
                        (appChange)="onCheckboxChange($event, 'ci-purchase-history-po')"
                      >
                      </app-checkbox>
                    </li>
                    <li class="catalog-list-filter-items" (click)="$event.stopPropagation()">
                      <app-checkbox
                        label="Selling history"
                        [disabled]="isFilterLoading"
                        [isChecked]="filterOptionModel.sellingHistory"
                        [fontSize]="12"
                        (appChange)="onCheckboxChange($event, 'ci-sale-history-ro')"
                      >
                      </app-checkbox>
                    </li>
                  </ul>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </ng-template>
    </p-tabPanel>
  </p-tabView>
</div>